import { zimbaApi } from '@/infrastructure/Configuration'
export default class TripAdvisorService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async getTripAdvisorRating(hotelCodes) {
    const url = `${zimbaApi}/hotels?` + hotelCodes.map(code => 'code=' + code).join('&')
    try {
      const { data } = await this.httpClient.get(url)
      return data.hotels
    } catch (e) {
      console.error('Unable to retrieve hotels: ', e)
      return []
    }
  }

  async getTripAdvisorSingleHotelRating(hotelCode) {
    const url = `${zimbaApi}/hotels/${hotelCode}/rating`
    const response = await this.httpClient.get(url)

    return response.data
  }
}
